<app-page-breadcrumb pageTitle="Números telefónicos"></app-page-breadcrumb>

@if (!isSuperAdmin) {
<div class="p-4 bg-warning-50 border border-warning-200 rounded-lg dark:bg-warning-500/10 dark:border-warning-500/20">
  <p class="text-warning-700 dark:text-warning-400">
    Solo el Super Admin del business puede gestionar los números telefónicos.
  </p>
</div>
} @else {
<app-component-card>
  <div class="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between mb-4">
    <div class="grid grid-cols-1 sm:grid-cols-3 gap-3 flex-1">
      <div>
        <label class="block text-xs font-medium text-gray-600 dark:text-gray-400 mb-1">Buscar</label>
        <input
          type="text"
          [(ngModel)]="filtroSearch"
          (ngModelChange)="buscar()"
          placeholder="Número, etiqueta o SID..."
          class="w-full px-3 py-2 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500/20 focus:border-brand-300"
        />
      </div>
      <div>
        <label class="block text-xs font-medium text-gray-600 dark:text-gray-400 mb-1">Tipo</label>
        <select
          [(ngModel)]="filtroType"
          (ngModelChange)="buscar()"
          class="w-full px-3 py-2 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white">
          <option value="">Todos</option>
          <option value="LOCAL">Local</option>
          <option value="TOLL_FREE">Toll Free</option>
          <option value="MOBILE">Móvil</option>
          <option value="VOIP">VoIP</option>
        </select>
      </div>
      <div>
        <label class="block text-xs font-medium text-gray-600 dark:text-gray-400 mb-1">Estado</label>
        <select
          [(ngModel)]="filtroActive"
          (ngModelChange)="buscar()"
          class="w-full px-3 py-2 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white">
          <option value="">Todos</option>
          <option value="true">Activos</option>
          <option value="false">Inactivos</option>
        </select>
      </div>
    </div>
    <ng-container *appHasPermission="'calls:create'">
      <app-button variant="primary" (btnClick)="nuevo()">+ Nuevo número</app-button>
    </ng-container>
  </div>

  @if (error) {
  <p class="mb-3 text-sm text-error-600 dark:text-error-400">{{ error }}</p>
  }

  @if (loading) {
  <div class="flex justify-center py-8">
    <div class="animate-spin rounded-full h-6 w-6 border-b-2 border-brand-500"></div>
  </div>
  } @else if (filtered.length === 0) {
  <p class="py-8 text-center text-sm text-gray-500 dark:text-gray-400">
    No hay números registrados.
  </p>
  } @else {
  <div class="overflow-x-auto rounded-lg border border-gray-200 dark:border-gray-700">
    <table class="min-w-full text-sm">
      <thead class="bg-gray-50 dark:bg-gray-800">
        <tr>
          <th class="px-3 py-2 text-left font-medium text-gray-600 dark:text-gray-400">Número</th>
          <th class="px-3 py-2 text-left font-medium text-gray-600 dark:text-gray-400">Etiqueta</th>
          <th class="px-3 py-2 text-left font-medium text-gray-600 dark:text-gray-400 w-24">Tipo</th>
          <th class="px-3 py-2 text-left font-medium text-gray-600 dark:text-gray-400 w-24">Default</th>
          <th class="px-3 py-2 text-left font-medium text-gray-600 dark:text-gray-400 w-28">Estado</th>
          <th class="px-3 py-2 text-left font-medium text-gray-600 dark:text-gray-400 w-20">Agente</th>
          <th class="px-3 py-2 text-right font-medium text-gray-600 dark:text-gray-400 w-44">Acciones</th>
        </tr>
      </thead>
      <tbody class="divide-y divide-gray-200 dark:divide-gray-700">
        @for (item of filtered; track trackById($index, item)) {
        <tr class="hover:bg-gray-50 dark:hover:bg-gray-800/50">
          <td class="px-3 py-2 font-mono text-gray-900 dark:text-white">{{ item.phoneNumber }}</td>
          <td class="px-3 py-2 text-gray-900 dark:text-white">{{ item.friendlyName || '—' }}</td>
          <td class="px-3 py-2 text-gray-600 dark:text-gray-400">{{ numberTypeLabel(item.numberType) }}</td>
          <td class="px-3 py-2">
            @if (item.isDefault) {
            <app-badge color="info">Default</app-badge>
            } @else {
            <span class="text-xs text-gray-400">—</span>
            }
          </td>
          <td class="px-3 py-2">
            @if (item.isActive) {
            <app-badge color="success">Activo</app-badge>
            } @else {
            <app-badge color="light">Inactivo</app-badge>
            }
          </td>
          <td class="px-3 py-2 text-gray-600 dark:text-gray-400">{{ item.agentId || '—' }}</td>
          <td class="px-3 py-2">
            <div class="flex items-center justify-end gap-1">
              @if (!item.isDefault) {
              <button
                type="button"
                (click)="marcarDefault(item)"
                [appDisableWithoutPermission]="'calls:edit'"
                title="Marcar como default"
                class="p-1.5 rounded-lg text-gray-500 hover:bg-gray-100 hover:text-brand-600 dark:text-gray-400 dark:hover:bg-gray-700">
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z"/>
                </svg>
              </button>
              }
              <button
                type="button"
                (click)="editar(item)"
                [appDisableWithoutPermission]="'calls:edit'"
                title="Editar"
                class="p-1.5 rounded-lg text-gray-500 hover:bg-gray-100 hover:text-brand-600 dark:text-gray-400 dark:hover:bg-gray-700">
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"/>
                </svg>
              </button>
              <button
                type="button"
                (click)="toggleActivo(item)"
                [appDisableWithoutPermission]="'calls:edit'"
                [title]="item.isActive ? 'Desactivar' : 'Activar'"
                class="p-1.5 rounded-lg text-gray-500 hover:bg-gray-100 hover:text-brand-600 dark:text-gray-400 dark:hover:bg-gray-700">
                @if (item.isActive) {
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636"/>
                </svg>
                } @else {
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
                </svg>
                }
              </button>
              <button
                type="button"
                (click)="eliminar(item)"
                [appDisableWithoutPermission]="'calls:delete'"
                title="Eliminar"
                class="p-1.5 rounded-lg text-gray-500 hover:bg-error-50 hover:text-error-600 dark:text-gray-400 dark:hover:bg-error-500/10">
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6M1 7h22M9 7V4a1 1 0 011-1h4a1 1 0 011 1v3"/>
                </svg>
              </button>
            </div>
          </td>
        </tr>
        }
      </tbody>
    </table>
  </div>
  }
</app-component-card>
}
